import GameInstance from "../GameInstance";
import ShopItem from "../SHOP/ShopItem";
import LOG, { log } from "../../../UTIL/LOG";

class QuestItem
{
    private gameInstance : GameInstance;
    public isPremium    : boolean;
    public unlocksAt    : number;
    public key          : string;
    public isLocked     : boolean = true;

    private saveKey     : string;
    public isConsumed   : boolean = false;
    public shopItem     : ShopItem;

    constructor( vars:any, isPremium:boolean )
    {
        this.gameInstance   = vars.gameInstance;
        this.unlocksAt      = vars.unlocksAt;
        this.key            = vars.key;
        this.isPremium      = isPremium;

        this.saveKey        = ( isPremium ? "P" : "F" ) + this.unlocksAt;
        this.shopItem       = this.gameInstance.Shop.items[ this.key ];
    }

    public refresh() : number
    {
        this.isConsumed = this.gameInstance.Quest.state[ this.saveKey ];
        this.isLocked   = this.isConsumed || this.unlocksAt > this.gameInstance.Quest.state.progression;

        return this.isLocked ? 0 : 1;
    }

    public get()
    {
        if( this.isLocked ) return;
 
        this.isConsumed = this.gameInstance.Quest.state[ this.saveKey ] = true;

        this.gameInstance.Quest.save();

        return this.shopItem.set( true ); 
    }
}

export default QuestItem;